import * as React from "react";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useMediaQuery } from "@mui/material";
import { useCallback, useMemo } from "react";

import { schema } from "../../../../../schemas/worklogDetail";
import "./addWorklogDialog.scss";
import { useResponsive } from "../../../../../hooks/useResponsive";
import {
  RFHTextField,
  RHFDateTimePicker,
  RHFTextEditor,
} from "../../../../../components/RFH";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";
import { useCreateWorklogMutation } from "../hooks/useWorklogDialogMutations";

export default React.memo( function AddWorklogCustomizedDialogs({
  showEdit,
  setShowEdit,
  heading,
  buttonName,
  addWorklog,
  setAddWorklog,
  cardId,
}) {
  const [isloading, setLoading] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useResponsive("down", "md");
  const { id } = useBoardIdByKey();

  const defaultValues = useMemo(
    () => ({
      date_time: moment(),
    }),
    []
  );

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState,
    ...methods
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });

  const { mutate: createWorklogMutate } = useCreateWorklogMutation({
    cardId,
    boardId: id,
    onSuccess: () => {
      setLoading(false);
      setAddWorklog(false);
    },
  });

  const handleClose = useCallback(() => {
    if (addWorklog === true) {
      setAddWorklog(false);
    }
    if (showEdit === true) {
      setShowEdit(false);
    }
  }, [addWorklog, setAddWorklog, showEdit, setShowEdit]);

  const submit = useCallback(
    (data) => {
      setLoading(true);
      createWorklogMutate({
        card_id: cardId,
        ...data,
      });
    },
    [cardId, createWorklogMutate]
  );

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submit)}>
        <FormDialog
          open={addWorklog}
          fullScreen={fullScreen}
          className={"add-worklog-dialog"}
          title={heading}
          handleClose={handleClose}
          buttonTxt={buttonName}
          handleSubmit={handleSubmit(submit)}
          disabled={isloading}
          cancelBtn={true}
          fullWidth={true}>
          <Typography gutterBottom>
            <div className={isMobile ? "" : "work-hour-box"}>
              <p className="work-hour-title">Work Hours</p>
              <RFHTextField name={"hours_spent"} className="work-hour" />
            </div>
          </Typography>
          <Typography>
            <p className="work-discription-title">Work Description</p>
            <div className="text-editor">
              <RHFTextEditor name={"work_performed"} />
            </div>
          </Typography>
          <Typography>
            <p className="work-date-title">Date</p>
            <div className="work-date-input">
              <RHFDateTimePicker name="date_time" />
            </div>
          </Typography>
        </FormDialog>
      </form>
    </FormProvider>
  );
})
